import styled from 'styled-components';
import { useMemo } from 'react';
import { useAppQuery } from '../../../../../services/reactQuery/useAppQuery';
import StaffHTTPService from '../../../../../services/HTTPService/staff/StaffHTTPService';
import { ChildId } from '../../../../../types';
import { AdditionalCostPackage } from './AdditionalCostPackage/AdditionalCostPackage';
import { EmptyDisplay } from '../../../../molecules';

type Props = {
    childId: ChildId;
    period: string;
};

const BillListContainer = styled('div')`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
`;

export const AdditionalCostList = ({ childId, period }: Props) => {
    const { data: additionalCostsSettlementData } = useAppQuery(
        'ADDITIONAL_COST_LIST',
        [childId, period],
        () =>
            StaffHTTPService.settlements.getAdditionalCostsSettlement({
                childId,
                period,
            }),
        {},
    );

    const data = useMemo(
        () => additionalCostsSettlementData?.additionalCostSummaryDtos ?? [],
        [additionalCostsSettlementData],
    );

    const size = useMemo(() => data.length, [data]);
    if (size === 0) {
        return <EmptyDisplay emptyInfo="Brak dodatkowych kosztów w tym miesiącu" />;
    }

    return (
        <BillListContainer>
            {data.map((item, index) => {
                const { detailsDto, corrections } = item;

                return (
                    <AdditionalCostPackage
                        detailsDto={detailsDto}
                        corrections={corrections}
                        childId={childId}
                        index={size - index - 1}
                    />
                );
            })}
        </BillListContainer>
    );
};
